import { useState } from "react";
import AppLayout from "./AppLayout";
import Container from "./Container";
import Header from "./Header";
import Notifications from "./Notifications";

function App() {
  const [isNewNotification, setIsNewNotification] = useState(true);

  return (
    <Container>
      <Header onSetNotification={setIsNewNotification} />
      <AppLayout>
        <Notifications isNewNotification={isNewNotification} />
      </AppLayout>
    </Container>
  );
}

export default App;
